@if (this.currentCompanyStore.loaded()) {
  <dw-grid-list-page
    [title]="'Doc::Menu:SalesPurchases' | abpLocalization"
    [activeView]="agGrid.activeView"
    (createAction)="createEntity()"
    [createActionLabel]="'::Add'"
    (deleteAction)="deleteEntities()"
    [enableExportBtn]="enableExport"
    [enableDeleteBtn]="enableDelete"
    (exportAction)="agGrid.export()"
    [toolbarActions]="toolbarActions()"
    [enableDuplicateBtn]="selectedEntities().length == 1"
    [showDuplicateBtn]="true"
    (duplicateAction)="duplicateSalesPurchase()"
    [hasQuickSearch]="true"
  >
    <dw-grid-ag-grid
      [columnDefs]="columns"
      [datasource]="datasource"
      [predefinedFilters]="predefinedFilters"
      (rowClicked)="rowClicked($event)"
      [(selectedRows)]="selectedEntities"
      (selectedRowsClicked)="selectedRowsClicked($event)"
      #agGrid
      [context]="GoliathDocumentEntityNames.CustomerSalesPurchase.shortName"
    >
    </dw-grid-ag-grid>
  </dw-grid-list-page>
}
